import { type AvatarSize } from '../avatar/avatar.types';
import { Location } from '../../icons/location';
import { type FlagCode } from '@doxyme/types';
import Box from '@mui/material/Box';
import { useTheme } from '../../../../theme';
import type { JSX } from 'react';
import { CSSObject } from '@emotion/react';

export type AvatarFlagProperties = {
  flagCode: FlagCode;
  size: AvatarSize;
  disabled?: boolean;
};

const LOCATION_SIZES: Record<AvatarSize, number> = {
  '3xl': 32,
  '2xl': 24,
  xl: 16,
  lg: 16,
  md: 12,
  sm: 8,
};

const LOCATION_POSITIONS: Record<AvatarSize, CSSObject> = {
  '3xl': { position: 'absolute', bottom: -7, right: -3 },
  '2xl': { position: 'absolute', bottom: -4, right: -4 },
  xl: { position: 'absolute', bottom: -8, right: -3 },
  lg: { position: 'absolute', bottom: -7, right: -2 },
  md: { position: 'absolute', bottom: -2, right: -2 },
  sm: { position: 'absolute', bottom: -2, right: -2 },
};

export const AvatarFlag = ({
  flagCode,
  size,
  disabled = false,
}: AvatarFlagProperties): JSX.Element => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'absolute',
        zIndex: 1,
        ...LOCATION_POSITIONS[size],

        '::after': disabled
          ? {
              content: '""',
              backgroundColor: theme.interactiveElement.disabled,
              position: 'absolute',
              inset: 0,
              borderRadius: theme.shape.radius100,
              zIndex: 1,
            }
          : undefined,
      }}
    >
      <Location flagCode={flagCode} size={LOCATION_SIZES[size]} />
    </Box>
  );
};
